import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-verify-email',
  imports: [RouterModule],
  templateUrl: './verify-email.component.html',
})
export class VerifyEmailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);

  isLoading = true;
  errorMessage: string | null = null;

  ngOnInit(): void {
    // DÉTAILS: L'utilisateur atterrit sur cette page en cliquant sur le lien dans son e-mail.
    // L'URL contiendra un token (ex: /verify-email?token=...).
    // On extrait ce token.
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.isLoading = false;
      this.errorMessage = 'Token de vérification manquant ou invalide.';
      return;
    }

    // DÉTAILS: On appelle le service d'authentification pour envoyer le token au backend.
    this.authService.verifyEmail(token).subscribe({
      next: () => {
        // En cas de succès, on arrête le chargement. Le template affichera le message de succès.
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage =
          err.error.message ||
          'La vérification a échoué. Le lien est peut-être expiré.';
        this.cdr.markForCheck();
      },
    });
  }
}
